export const FETCH_SERVICE_HEADER = 'SERVICE_HEADER/FETCH_REQUEST';
export const FETCH_SERVICE_HEADER_SUCCESS = 'SERVICE_HEADER/FETCH_SUCCESS';
export const FETCH_SERVICE_HEADER_FAILURE = 'SERVICE_HEADER/FETCH_FAILURE';
export const SELECT_DMS_ENTRY = 'SERVICE_HEADER/SELECT_ENTRY';
export const OPEN_MODAL = 'SERVICE_HEADER/SELECT_MODAL/OPEN';
export const CLOSE_MODAL = 'SERVICE_HEADER/SELECT_MODAL/CLOSE';
